module.exports = __webpack_public_path__ + "static/media/bebas_neue_bold.9d45c6d7.otf";